import ButtonUnstyled from "@mui/base/ButtonUnstyled";
import { styled } from "@mui/material";

 export const CleanButton = styled(ButtonUnstyled)(({theme}) => ({
  padding: 0,
  margin: 0,
  border: 0,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  color: theme.palette.primary.main,
  fontWeight: 700,
  fontSize: 16,
  '&:hover': {
    color: theme.palette.primary.dark,
  },
}));